export class SelectedUserClientToAdd {
    clientId: number;
    clientName: string;
    isAdmin: boolean;
    isCustodian: boolean;
    isReport: boolean;
    viewReferralsOnly: boolean;

    constructor() {
        this.clientId = 0;
        this.clientName = "";
        this.isAdmin = false;
        this.isReport = false;
        this.viewReferralsOnly = false;
    }
}